export default {"src":"/_next/static/media/code.2789320c.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};